
class GdprConsentCtrl  {
    constructor(GeneralOptions) {
        'ngInject';

        this.GeneralOptions = GeneralOptions;
    }

    $onInit() {
        this.isGDPRConsentRequired = this.GeneralOptions.isGDPRConsentRequired;
        this.displayPolicyStatementHTMLContent = this.GeneralOptions.displayPolicyStatementHTMLContent;
        this.policyStatementHTMLContent = this.GeneralOptions.policyStatementHTMLContent;
    }
}

export { GdprConsentCtrl as controller };


// WEBPACK FOOTER //
// ../node_modules/bookingbug-angular/src/core/gdpr-consent/gdpr-consent.controller.js